import { useState } from 'react';
import styles from './CardSection.module.css';
import imgHospital from '../../../../assets/images/event/병원동행.jpg';
import imgLife from '../../../../assets/images/event/생활지원.jpg';
import imgDigital from '../../../../assets/images/event/디지털지원.jpg';
import imgWelfare from '../../../../assets/images/event/복지상담.jpg';

const cards = [
  {
    title: '병원, 생활동행',
    type: ['- 병원동행', '- 관공서, 은행 방문', '- 산책, 장보기 동행'],
    img: imgHospital,
    overlayColor: 'rgba(240, 100, 80, 0.75)',
  },
  {
    title: '생활지원',
    type: ['- 가스레인지, 가전제품 건전지교체', '- 형광등 교체', '- 중소형 조립가구 조립'],
    img: imgLife,
    overlayColor: 'rgba(60, 130, 200, 0.75)',
  },
  {
    title: '디지털지원',
    type: ['- 스마트폰 사용교육', '- 앱 사용교육', '- 가전제품 설정안내'],
    img: imgDigital,
    overlayColor: 'rgba(110, 70, 180, 0.75)',
  },
  {
    title: '복지상담',
    type: ['- 노인장기요양등급 신청지원', '- 기초생활수급자 신청지원', '- 복지정보 안내 및 상담'],
    img: imgWelfare,
    overlayColor: 'rgba(60, 155, 100, 0.75)',
  },
];

function CardSection() {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <section className={styles.section}>
      <div className={styles.grid}>
        {cards.map((card, index) => {
          const isActive = index === activeIndex;
          const bgImage = isActive
            ? `linear-gradient(180deg, #FFFFFF 15%, rgba(255,255,255,0) 50%), url(${card.img})`
            : `linear-gradient(0deg, ${card.overlayColor}, ${card.overlayColor}), url(${card.img})`;

          return (
            <div
              key={card.title}
              className={isActive ? `${styles.card} ${styles.cardActive}` : styles.card}
              style={{ backgroundImage: bgImage }}
              onClick={() => setActiveIndex(index)}
            >
              {isActive ? (
                <>
                  <div className={styles.title}>{card.title}</div>
                  <ul className={styles.typeList}>
                    {card.type.map((item) => (
                      <li key={item} className={styles.typeItem}>{item}</li>
                    ))}
                  </ul>
                </>
              ) : (
                <div className={styles.titleInactive}>{card.title}</div>
              )}
            </div>
          );
        })}
      </div>
    </section>
  );
}

export default CardSection;
